module.exports = __webpack_public_path__ + "static/media/LetsGetDressed.127052c1.jpg";